// Monospace text from the terminal or the agent: sanitised again on the phone, with the daemon's
// change markers ("[masked]", "[1,240 characters omitted…]") made visible (SPEC 3.11).
import { displayText, splitMarkers } from "../lib/sanitize";

export function CommandText({ text, label, plain = false }: { text: string | undefined; label?: string; plain?: boolean }) {
  const clean = displayText(text);
  if (!clean) return null;
  const parts = splitMarkers(clean);
  return (
    <pre className={`cmd${plain ? " plain" : ""}`} aria-label={label} tabIndex={0}>
      {parts.map((p, i) => (p.kind === "marker" ? <mark key={i} className="marker">{p.value}</mark> : <span key={i}>{p.value}</span>))}
    </pre>
  );
}

/** True when the display text carries any change marker, so the card can say so next to the Allow button. */
export function hasMarkers(text: string | undefined): boolean {
  return !!text && splitMarkers(displayText(text)).some((p) => p.kind === "marker");
}
